export default __webpack_public_path__ + "static/media/inaccessible.a4465288.png";